import { useEffect } from "react";
import { useTranslation } from "src/i18n";
import { Breadcrumb, BreadcrumbItem } from ".";

export interface PageTitleProps {
    hidden?: boolean;
    children: string;
    breadcrumbItems?: BreadcrumbItem[];
    showBreadcrumb?: boolean;
}

export function PageTitle(props: PageTitleProps) {
    const { children, hidden } = props;
    const { t } = useTranslation('common');
    useEffect(() => {
        document.title = t('pageTitle', children);
    }, [t, children]);
    if (hidden) {
        return null;
    }
    return (
        <>
            {props.showBreadcrumb &&
                <Breadcrumb currentTitle={children} items={props.breadcrumbItems} />}
            <h1>{children}</h1>
        </>
    );
}
